import {
  CmdFromRenderer,
  CmdTypeFromRender,
  StopCmdParam,
  TurnOffEngineCmdParam,
} from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/ServiceCommand/CmdFromRenderer';
import { ITimingStrategy } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/ITimingStrategy';
import { TimingStrategyDelegate } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/TimingStrategyDelegate';
import { CoSyncInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import { CoSyncStatus, CoSynStatusInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncEvent';

export class ManulTimingStrategy implements ITimingStrategy {
  constructor(servceDelegate: WeakRef<TimingStrategyDelegate>, coSyncInfo: CoSyncInfo) {
    this.servceDelegate = servceDelegate;
    this.coSyncInfo = coSyncInfo;
  }

  private servceDelegate: WeakRef<TimingStrategyDelegate>;
  private coSyncInfo: CoSyncInfo;

  /**
   * 处理恢复上一次的状态
   *
   * @memberof ManulTimingStrategy
   */
  public handleRestore(): void {
    this.restoreIdel();
  }

  /**
   * 处理创建后的初次状态
   *
   * @memberof ManulTimingStrategy
   */
  public handleJustCreated(): void {
    this.restoreIdel();
  }

  /**
   * 处理开始
   * 手动模式下开始就启动引擎
   *
   * @return {*}  {Promise<void>}
   * @memberof ManulTimingStrategy
   */
  public async handleStart(): Promise<void> {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('handleStart aServceDelegate is undefined');
      return;
    }
    await aServceDelegate.applyCommand({ cmdType: CmdTypeFromRender.TURN_ON_ENGINE } as CmdFromRenderer);
  }

  /**
   * 处理停止
   * 手动模式下开始就关闭引擎
   *
   * @return {*}  {Promise<void>}
   * @memberof ManulTimingStrategy
   */
  public async handleStop(stopParam: StopCmdParam): Promise<void> {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('handleStop aServceDelegate is undefined');
      return;
    }
    await aServceDelegate.applyCommand({
      cmdType: CmdTypeFromRender.TURN_OFF_ENGINE,
      param: { isSilent: stopParam.isSilent ?? false } as TurnOffEngineCmdParam,
    } as CmdFromRenderer);
  }

  /**
   * 处理状态变化
   *
   * @param {CoSynStatusInfo} status
   * @return {*}  {Promise<void>}
   * @memberof ManulTimingStrategy
   */
  public async onUpdateStatus(status: CoSynStatusInfo): Promise<void> {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('restoreStop aServceDelegate is undefined');
      return;
    }

    // 手动同步下，如果完成了，就停止
    if ([CoSyncStatus.STATUS_SUCCESS, CoSyncStatus.STATUS_ERROR].includes(status.status)) {
      await ManulTimingStrategy.slicentStopService(aServceDelegate);
    }

    aServceDelegate.emitTaskChange(status);
  }

  private static async slicentStopService(servceDelegate: TimingStrategyDelegate): Promise<void> {
    const param: StopCmdParam = {
      isFromUIAction: false,
      isSilent: true,
    };
    const stopCmd: CmdFromRenderer = {
      cmdType: CmdTypeFromRender.STOP,
      param,
    };
    await servceDelegate.applyCommand(stopCmd);
  }

  private restoreIdel() {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('restoreNone aServceDelegate is undefined');
      return;
    }

    // 如果没有上一次状态（新创建的），要通知一次等待中的状态
    aServceDelegate.emitTaskChange(aServceDelegate.buildIdleStatus());
  }
}
